/*
* This reducer file handles reducer's state for all actions that are related to signup
*/
const initialState = {
	setStep: 1,
	setPlan: 'simpro',
	openPopup: false,
	signupStage: 'companySetup',
	signupUser: null,
	payment: null,
	team: null,
	contact: false,
	simproApi: false,
	forgatPass: '',
	subscriptions: null,
	addCompanyerror: {},
	validateCompanyErrors:{},
	validatedCompany:false,
	ispaymentRequest: false,
	disableButtonStatus: false,
	disableaAuthorizeButton: false,
	buttonDisableInteg: false,
	disableButtonTeamStatus: false,
	incorrectUrl:false,
	apiAuthorized: false,
	simproCompanies: null,
	disableVerifyButton: false,
	apiVerified: false,
	verifyingApi: false,
	tncSignupText: 'Please select terms of service.',
	redirecturl: null

};

export default function signUpReducer(state = initialState, action) {
	switch (action.type) {
		case 'UPDATE_PLAN':
			return Object.assign({}, state, {
				setPlan: action.payload.newplan,
				openPopup: true,
			});
		case 'CANCEL_POPUP':
			return Object.assign({}, state, {
				openPopup: false,
			});
		case 'ADD_COMPANY_REQUEST':
			return Object.assign({}, state, {
				disableButtonStatus: true
			});

		case 'ADD_COMPANY_SUCCESS':
			if(action.users){
				// window.localStorage.setItem('redirecturl', action.redirecturl);
				window.localStorage.setItem('temp_company_id', action.users.company._id);
      			window.localStorage.setItem('temp_user_id', action.users.user._id);
			}
			
			return Object.assign({}, state, {
				signupUser: action.users,
				setStep: 2,
				redirecturl: action.redirecturl,
				disableButtonStatus: false
			});
		case 'ADD_COMPANY_FAILURE':
			return Object.assign({},state,{
				addCompanyerror: action.errors,
				disableButtonStatus: false,
			});
		// case 'ADD_PAYMENT_REQUEST':
		// 	return Object.assign({},state,{
		// 		ispaymentRequest: true
		// 	});
		// case 'ADD_PAYMENT_SUCCESS':
		// 	return Object.assign({}, state, {
		// 		payment: action.payment,
		// 		setStep: 3,
		// 		ispaymentRequest: false
		// 	});
		// case 'ADD_PAYMENT_FAILURE':
		// 	return Object.assign({}, state, {
		// 		ispaymentRequest: false
		// 	});


		case 'ADD_INTENT_PAYMENT_REQUEST':
			return Object.assign({},state,{
				ispaymentRequest: true
			});
		case 'ADD_INTENT_PAYMENT_SUCCESS':
			// console.log("here is the response", action.payment)
			return Object.assign({}, state, {
				client_secret_for_auth: action.payment.setup_intent,
				setStep: 2,
				ispaymentRequest: false,
				paid:action.payment.paid
			});

		case 'INTENT_PAYMENT_RESET':
			return Object.assign({}, state, {
				client_secret_for_auth: null,
				// setStep: 2,
				// ispaymentRequest: false
			});

		case 'PAYMENT_SUCCESS':
	
			return Object.assign({}, state, {
				client_secret_for_auth: null,
				setStep: 2,
				payment:true,
				paid:null
			});

		case 'ADD_INTENT_PAYMENT_FAILURE':
			return Object.assign({}, state, {
				ispaymentRequest: false
			});

		case 'ADD_TEAM_MEMBER':
			return Object.assign({}, state, {
				disableButtonTeamStatus: true,
			});
		case 'ADD_TEAM_MEMBER_SUCCESS':
			return Object.assign({}, state, {
				team: action.team,
				setStep: 4,
				disableButtonTeamStatus: false,
			});
		case 'ADD_TEAM_MEMBER_FAIL':
			return Object.assign({}, state, {
				disableButtonTeamStatus: false,
			});
		case 'ADD_CONTACT':
			return state;
		case 'ADD_CONTACT_SUCCESS':
			return Object.assign({}, state, {
				contact: true,
			});
		case 'ADD_SIMPRO_API':
			return Object.assign({}, state, {
				buttonDisableInteg: true,
			});
		case 'ADD_SIMPRO_API_SUCCESS':
			return Object.assign({}, state, {
				simproApi: true,
				buttonDisableInteg: false,
			});
		case 'ADD_SIMPRO_API_FAIL':
			return Object.assign({}, state, {
				simproApi: true,
				buttonDisableInteg: false,
			});
		case 'RESET_PASSWORD_SUCCESS':
			return Object.assign({}, state, {
				forgatPass: action.forgatPass,
			});
		case 'FETCH_SUBSCRIPTION_REQUEST':
			return state;
		case 'FETCH_SUBSCRIPTION_SUCCESS':
			return Object.assign({}, state, {
				subscriptions:action.subscription,
			});
		case 'VALIDATE_COMPANYDATA_REQUEST':
			return Object.assign({},state,{
				validateCompanyErrors: {},
				disableButtonStatus: true,
			});
		case 'VALIDATE_COMPANYDATA_FAILURE':
			return Object.assign({},state,{
				validateCompanyErrors: action.errors,
				disableButtonStatus: false,
			});
		case 'VALIDATE_COMPANYDATA_SUCCESS':
			return Object.assign({},state,{
				validatedCompany:true,
				disableButtonStatus: false,
			});
		case 'CANCEL_COMPANY_VALIDATION':
			return Object.assign({},state,{
				validatedCompany:false,
				disableButtonStatus: false,
			});
		
		case 'API_AUTHORIZE_REQUEST':
			return Object.assign({},state,{
				disableaAuthorizeButton: true,
				incorrectUrl:false,
				apiAuthorized: false
			});
		case 'API_AUTHORIZE_SUCCESS':
			return Object.assign({},state,{
				disableaAuthorizeButton: true,
				incorrectUrl:false,
				apiAuthorized: true
			});
		case 'API_AUTHORIZE_FAILURE':
			return Object.assign({},state,{
				disableaAuthorizeButton: false,
				incorrectUrl:true,
				apiAuthorized: false
			});
		case 'CHECK_COMPANIES_API_SUCCESS':
		    return Object.assign({},state,{
		        simproCompanies:action.apiAuthorize.companies
		    });
		case 'VERIFY_SIMPRO_USERPASS_REQUEST':
			return Object.assign({},state,{
				disableVerifyButton: true,
				apiVerified: false,
				verifyingApi: true
			});
		case 'VERIFY_SIMPRO_USERPASS_SUCCESS':
			return Object.assign({},state,{
				disableVerifyButton: true,
				apiVerified: true,
				verifyingApi: false
			});
		case 'VERIFY_SIMPRO_USERPASS_FAILURE':
			return Object.assign({},state,{
				disableVerifyButton: false,
				apiVerified: false,
				verifyingApi: false
			});
		case 'TOGGLE_TNC_SIGNUP':
			return Object.assign({},state,{
				tncSignupText: action.text,
			});
		default:
			return state;
	}
}



// WEBPACK FOOTER //
// ./src/Reducers/signup.js